
import {AppConstants, StringConstants} from "./constants";
import {EXCESS_VARIANCE_REASON, EXTERNAL_VENDOR_SHORT_REASON, STATION_SHORT_VARIANCE_REASON, VarianceClients, VarianceReasonFormat, ONLY_ISSUE_LINK_REGEX, DEFAULT_STATION_SHORT_CODE} from "../common/remittanceV2Constants";
import { getStationCode } from "../../network/NetworkUtil";
import Moment from "moment";

export function oldTimeZoneMapper(timezone) {
    if (!timezone) {
        return timezone;
    }
    switch(timezone.trim()) {
        case "US/Eastern":
            return "America/New_York";
        case "US/Central":
            return "America/Chicago";
        case "US/Pacific":
            return "America/Los_Angeles";
        case "US/Mountain":
            return "America/Denver";
        case "US/Arizona":
            return "America/Phoenix";
        case "IST":
            return "Asia/Kolkata";
        default:
            return timezone.trim();
    }
}

export function handleBlankValue(str) {
    return str ? str : '-';
}

/**
 * This function check if provided url is a valid URL or not
 * @param issueLink
 * @returns {boolean}
 */
function isIssueLinkValid(issueLink) {
    let isValidURL = issueLink === undefined || issueLink === "" || !((!issueLink) ||
        ((issueLink.indexOf("tt.amazon.com/") === -1) &&
            (issueLink.indexOf("http://tt.amazon.com/") === -1) &&
            (issueLink.indexOf("https://tt.amazon.com/") === -1) &&
            (issueLink.indexOf("http://t.corp.amazon.com/") === -1) &&
            (issueLink.indexOf("https://t.corp.amazon.com/") === -1) &&
            (issueLink.indexOf("issues.amazon.com/") === -1) &&
            (issueLink.indexOf("http://issues.amazon.com/") === -1) &&
            (issueLink.indexOf("https://issues.amazon.com/") === -1) && 
            (issueLink.indexOf("sim.amazon.com/") === -1) &&
            (issueLink.indexOf("http://sim.amazon.com/") === -1) &&
            (issueLink.indexOf("https://sim.amazon.com/") === -1)));
    console.log("Checking URL : " + isValidURL);
    return isValidURL;
}

function isValidRemittanceCode(remittanceCode, currencyCode) {
    console.log("Remittance Code : " + remittanceCode + " Currency : " + currencyCode + " " + remittanceCode !== undefined);
    let remittanceCodeRegex = AppConstants.REMITTANCE_ID_REGEX[currencyCode];
    return remittanceCode !== undefined && remittanceCode.match(remittanceCodeRegex)
}

function isValidCoinRemittanceCode(remittanceCode) {
    console.log("Remittance Code : " + remittanceCode);
    let remittanceCodeRegex = AppConstants.COIN_DEPOSIT_CODE_REGEX;
    return remittanceCode !== undefined && remittanceCode.match(remittanceCodeRegex)
}

/**
 * Return the human readable string i.e. removes the `_` with ` ` and capitalize first letter of every word
 * @param {String} label 
 * @returns String
 */
export function getReadableLabel(label) {
    const definedVarianceReason = [...EXCESS_VARIANCE_REASON, ...STATION_SHORT_VARIANCE_REASON, ...EXTERNAL_VENDOR_SHORT_REASON];
    const varianceReason = definedVarianceReason.filter(varianceReason => varianceReason.reasonCode === label)[0];
    // if translation is already defined then return that
    if (varianceReason) {
        return varianceReason.reasonLabel;
    }
    // otherwise, translate 
    var fragments = label.split('_');
    for (let i=0; i<fragments.length; i++) {
        fragments[i] = fragments[i].charAt(0).toUpperCase() + fragments[i].toLowerCase().slice(1);
    }
    return fragments.join(' ');
}

/**
 * parse the variance reason and return the variance segment that is required
 * @param varianceReason 
 * @param value 
 * @returns 
 */
export function parseVarianceReason(varianceReason, value) {
    return varianceReason ? varianceReason.split(StringConstants.SEPARATOR)[value] : undefined;
}

/**
 * Call back function to filter the variances from SSC(boson) side
 * @param variance 
 * @returns boolean
 */
export const filterBosonVariance = (variance) => {
    return parseVarianceReason(variance.reason, VarianceReasonFormat.CLIENT) === VarianceClients.BOSON;
}

/**
 * Call back function to filter the variance with status DEFAULT_STATION_SHORT_CODE
 * @param variance 
 * @returns boolean
 */
export const filterDefaultShortVariance = variance => {
    return parseVarianceReason(variance.reason, VarianceReasonFormat.REASON_CODE) === DEFAULT_STATION_SHORT_CODE;
}

/**
 * method to convert an 1D array to 2D grid with column value equals to groupByValue
 * @param {*} dataList 
 * @param {*} groupByValue 
 * @returns 
 */
export const groupBy = (dataList, groupByValue) => {
    let group = -1;
    const result = [];
    for (let i = 0; i < dataList.length; i++) {
        if (i % groupByValue === 0) {
            result.push([]);
            group++;
        }
        result[group].push(dataList[i]);
    }

    return result;
}

/**
 * Method to get the RegExp for issue link
 * @returns RegExp
 */
export const getIssueLinkRegExp = () => {
    return new RegExp(ONLY_ISSUE_LINK_REGEX);
};

/**
 * Method to return the request body for getRemittanceRequest
 * @returns any
 */
export const getRemittanceRequestParams = () => {
    return {
        stationCode: getStationCode(),
        startDate: Date.parse(Moment().subtract(15, StringConstants.DAYS).format(StringConstants.YYYY_MM_DD)),
        endDate: Date.parse(Moment().format(StringConstants.YYYY_MM_DD)) + 86400000 //Add 1 extra day to provide today's data
    }
}

/**
 * Group together the variance which are having same variance reason code
 * @param varianceMap 
 * @param variance 
 */
export const insertVarianceByUniqueReasonCode = (varianceMap, variance) => {
    const reason = parseVarianceReason(variance.reason, VarianceReasonFormat.REASON_CODE);
    if (varianceMap[reason]) {
        // If variance already exists with specific reason code then add up the amount for that reason code
        varianceMap[reason].amount.value += variance.amount.value;
    } else {
        varianceMap[reason] = variance;
    }
}

export default {isIssueLinkValid, isValidRemittanceCode, isValidCoinRemittanceCode}


// WEBPACK FOOTER //
// ./src/component/common/commonUtils.js